// Controllers del panel Admin::.
// Importado desde controllers/index.js via `import "./admin"`.
// Centraliza el registro de todos los Stimulus controllers del namespace admin
// para mantener el index.js principal libre de registros admin--*.

import { application } from "../application";

// Íconos FontAwesome propios del admin (library.add).
import "./icons";

import SidebarController from "./sidebar_controller";
application.register("admin--sidebar", SidebarController);

import SearchDebounceController from "./search_debounce_controller";
application.register("admin--search-debounce", SearchDebounceController);

import ThemeController from "./theme_controller";
application.register("admin--theme", ThemeController);

import ToggleSubmitController from "./toggle_submit_controller";
application.register("admin--toggle-submit", ToggleSubmitController);

import UserFormController from "./user_form_controller";
application.register("admin--user-form", UserFormController);

import DiscountFormController from "./discount_form_controller";
application.register("admin--discount-form", DiscountFormController);

import FlashController from "./flash_controller";
application.register("admin--flash", FlashController);

import MetricInfoController from "./metric_info_controller";
application.register("admin--metric-info", MetricInfoController);

import DateFlatpickrController from "./date_flatpickr_controller";
application.register("admin--date-flatpickr", DateFlatpickrController);

import FrameSkeletonController from "./frame_skeleton_controller";
application.register("admin--frame-skeleton", FrameSkeletonController);

import ClpRutValidateController from "./clp_rut_validate_controller";
application.register("admin--clp-rut-validate", ClpRutValidateController);

import ModalFrameController from "./modal_frame_controller";
application.register("admin--modal-frame", ModalFrameController);

import DropdownController from "./dropdown_controller";
application.register("admin--dropdown", DropdownController);
